import {
    Box,
    FormControlLabel,
    IconButton,
    Paper,
    Radio,
    RadioGroup,
} from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { CloseIcon, SettingsIcon } from '../icons';

export type FilterMode = 'LogicalAnd' | 'LogicalOr';
type RespondentFilterSettingsProps = {
    filterMode: FilterMode;
    onChangeFilterMode(filterMode: FilterMode): void;
};
export const RespondentFilterSettings = (
    props: RespondentFilterSettingsProps,
) => {
    const [visible, setVisible] = useState(false);
    if (!visible) {
        return (
            <Box
                sx={(theme) => ({
                    textAlign: 'right',
                    color: theme.bino.color.white,
                    mb: -3, // Closer to the form below, no need to take up extra empty space
                })}
            >
                <IconButton
                    sx={(theme) => ({ color: theme.bino.color.palePurple })}
                    onClick={() => setVisible(!visible)}
                >
                    <SettingsIcon size={16} />
                </IconButton>
            </Box>
        );
    }
    return (
        <Paper sx={{ p: 2 }}>
            <IconButton
                sx={() => ({
                    float: 'right',
                    mt: -1,
                    mr: -1,
                })}
                size="small"
                onClick={() => setVisible(!visible)}
            >
                <CloseIcon size={12} />
            </IconButton>

            <h3>
                <FormattedMessage defaultMessage="Filter settings" />
            </h3>
            <RadioGroup
                value={props.filterMode}
                onChange={(event) =>
                    props.onChangeFilterMode(event.target.value as FilterMode)
                }
            >
                <FormControlLabel
                    value="LogicalAnd"
                    control={<Radio />}
                    label={
                        <FormattedMessage defaultMessage="Selects respondents that matches all choices" />
                    }
                />
                <FormControlLabel
                    value="LogicalOr"
                    control={<Radio />}
                    label={
                        <FormattedMessage defaultMessage="Selects respondents that matches any choice" />
                    }
                />
            </RadioGroup>
        </Paper>
    );
};
